import {Component, Inject, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, Validators} from "@angular/forms";
import {LocalStorageService} from "angular-2-local-storage";
import {WindowRefService} from "../../utils/window.service";
import {FormService} from "../../utils/form.service";
import {AppService} from "../../utils/app.service";
import {AnalyticsService} from "../../utils/analytics.service";
@Component({
    selector: 'login-page',
    template: require('./login.html'),
})

export class LoginPageComponent implements OnInit{
    private _window: any;
    private loginForm = {
        form: null,
        $submitting: false,
        $visible: false,
        $errorMsg:'',
        username: '',
        password: '',
        captcha: null
    };
    @Input() params : any;
    isSproutMode = process.env.MODE === 'SPROUT';
    constructor(
        @Inject(AppService) private app: any,
        @Inject(AnalyticsService) private Analytics: any,
        @Inject(FormService) private Form: any,
        private localStorageService: LocalStorageService,
        windowRef: WindowRefService,
        @Inject(FormBuilder) private fb:FormBuilder,
    ){
        this._window = windowRef.nativeWindow;
        this.loginForm.form = this.fb.group({
                username: [this.loginForm.username, [
                    Validators.required,
                    Validators.email
                ]],
                password: [this.loginForm.password, [
                    Validators.required,
                ]]
            });
        if (this._window.ApiConfig.captcha_key) {
            this.loginForm.form.addControl('captcha', new FormControl(
                this.loginForm.captcha,
                Validators.required
                )
            );
        }
    }

    onLogin() {
        this.loginForm.$submitting = true;
        this.app.login(this.loginForm);
    };

    onInvalid() {
        this.Analytics.trackEvent('SSO Sign In', 'Error', 'Provide required information');
    };

    login() {
        this.Form.submit(
            this.loginForm,
            null,
            this.onLogin.bind(this),
            null,
            this.onInvalid.bind(this)
        );
    };
    ngOnInit(){
        let appParams = <any>this.localStorageService.get('params');
        if (!appParams || !appParams.client_id) {
            this.app.setDefaultParams();
            appParams = <any>this.localStorageService.get('params');
        }

        if (this.params.error) {
            this.loginForm.$visible = true;
            this.loginForm.$errorMsg = this.params.error;
            this.Analytics.trackEvent('SSO Sign In', 'Error', this.params.error);
        } else if (this.params.access_token) {
            this._window.location.href = appParams.redirect_uri + '&access_token=' + this.params.access_token;
        } else {
            if(this.params.username){
                this.loginForm.username = this.params.username;
            }
            this.loginForm.$visible = true;
        }
    };
}
